export const MONTHLY_SIGHTINGS_TITLE = 'Peak Months';
export const MONTHLY_SIGHTINGS_HELPER = 'Most observations';
export const MONTHLY_SIGHTINGS_EMPTY_LABEL = 'No sightings recorded';
export const MONTHLY_SIGHTINGS_MIN_BAR_HEIGHT = 14;
